import React, {useState, useEffect} from "react";
import {Button, Paper, Box, Autocomplete, TextField, Typography} from '@mui/material';
import Header from "../Common/Header/Header";
import Sidenav from "../Common/Sidenav/Sidenav";
import commonService from "../../services/common-service";
import Spinner from "../../shared/Spinner";
import SnackAlert from "../../shared/SnackAlert";
import { useNavigate, useParams } from "react-router-dom";
import INS_GEOMETRY from "./INS_GEOMETRY";
import router from "../../routePaths/routePaths";

export default function AddInstallation() {
    let navigate = useNavigate();
    const {domain} = useParams();
    const [installations, setInstallations] = useState([]);
    const [alert, setAlert] = React.useState(false);
    const [msg, setMsg] = React.useState('');
    const [severity, setSeverity] = React.useState('');
    const [selectedClonedIns, setSelectedClonedIns] = useState(null);
    const [spinner, setSpinner] = React.useState(false);
    const [inputField, setInputField] = useState({});
    const [geometry, setGeometry] = useState([
        { lat: 52.52549080781086, lng: 13.398118538856465 }
    ]);
    const [geometryQuery, setGeometryQuery] = useState('');
    const [center, setCenter] = useState({lat: 52.52549080781086, lng: 13.398118538856465})
    const [clonedData, setClonedData] = useState({})
    
    const handleChange=(e) => {
        setInputField({...inputField, [e.target.name]: e.target.value});
    }

    const getInstalltions=async() => {
        setSpinner(true);
        const user = JSON.parse(sessionStorage.getItem('userLogged'));
        let body = {domain: domain};
        if(user.email == "cwpadmin"){
            body.ins_description = 'cwp'
        }
        const res = await commonService.get_integra_installtions(body);
        setInstallations(res.data);
        setSpinner(false);
    }

    const onInsSelect=async(newValue) => {
        if(newValue == null){
            return;
        }
        setSelectedClonedIns(newValue);
        const data = await commonService.cloneInstallationData({
            ins_id: newValue.ins_standard_city_id,
            domain: domain
        });
        setClonedData(data)
    }

    const handleSubmit=async(e) => {
        e.preventDefault();
        if(!geometryQuery){
            setMsg('Select Polygon Geometry for the Installation');
            setSeverity('error');
            setAlert(true);
            return
        }
        let body = {};
        body.sql1= generateCloneSql(
            clonedData.dbpicInstallation,     // API data
            'INSTALLATIONS',                   // table name
            null,   
            {
                INS_ID: inputField.ins_id,
                INS_DESCRIPTION: inputField.ins_name,
                INS_SHORTDESC: inputField.ins_name.substring(0, 3).toUpperCase()
            }
        );
        body.sql2= generateCloneSql(
            clonedData.externalProvidersIns,     // API data
            'EXTERNAL_PROVIDERS_INSTALLATIONS',                   // table name
            'EXPRI_ID',
            {
               EXPRI_INS_ID: inputField.ins_id 
            }
        );
        body.sql3= generateCloneSql(
            clonedData.externalProvidersApiMethods,     // API data
            'EXTERNAL_PROVIDERS_API_METHODS',                   // table name
            'EXPRAM_ID',                // primary key
            {
               EXPRAM_INS_ID: inputField.ins_id 
            }
        );
        body['domain'] = domain;
        setSpinner(true);
        const res = await commonService.insert_to_db(body);
        setSpinner(false);
        if(res.data == true){
            setMsg("City Added Successfully in dbPIC");
            setSeverity('success');
            intergraInsertion();
        }else{
            setMsg(res.data.map(x=>{return x}).join('\n\n'))
            setSeverity('error');
            setGeometry([]);
        }
        setAlert(true);
    }

    const intergraInsertion=async() => {
        let body = {};
        body.sql1= generateCloneSql(
            clonedData.integraInstallation,     // API data
            'INSTALLATIONS',                   // table name
            null,   
            {
                INS_ID: inputField.ins_id,
                INS_DESCRIPTION: inputField.ins_name,
                INS_SHORTDESC: inputField.ins_name.substring(0, 3).toUpperCase(),
                INS_STANDARD_CITY_ID: inputField.ins_id
            }
        );
        body.sql2= geometryQuery;
        if(clonedData.installationsFinanParsOpeType.length){
            body.sql3= "INSERT INTO FINAN_DIST_OPERATORS (FDO_ID, FDO_DESCCRIPTION, FDO_MAIN, FDO_ISCOUNCIL)\n"+
            "VALUES ("+(Number(clonedData.installationsLastIds[0]?.FDO_ID) + 1)+",'"+inputField.ins_name+"',0,0);"

            body.sql4= generateCloneSql(
                clonedData.finanDistOperatorInstallation,     // API data
                'FINAN_DIST_OPERATORS_INSTALLATIONS',                   // table name
                null,
                {
                    FDOI_ID: Number(clonedData.installationsLastIds[1]?.FDOI_ID) + 1,
                    FDOI_FDO_ID: Number(clonedData.installationsLastIds[0]?.FDO_ID) + 1,
                    FDOI_INS_ID: inputField.ins_id,
                }
            );

            body.sql5= generateCloneSql(
                clonedData.installationsFinanParsOpeType,     // API data
                'INSTALLATIONS_FINAN_PARS_OPE_TYPE',                   // table name
                'INSF_ID',                // primary key
                {
                    INSF_INS_ID: inputField.ins_id 
                }
            );
        }
        body['domain'] = domain;
        setSpinner(true);
        const res = await commonService.insert_to_integra(body);
        setSpinner(false);
        if(res.data == true){
            setMsg("City Added Successfully in IntegraMobile");
            setSeverity('success');
            navigate(router.select_profile+'/'+domain)
        }else{
            setMsg(res.data.map(x=>{return x}).join('\n\n'))
            setSeverity('error');
            setGeometry([]);
        }
        setAlert(true);
    }

    const generateCloneSql = (
        data,
        tableName,
        primaryKey = null,
        columnValues = {}
    ) => {
        if (!data || !data.length) {
            return `-- No data found for ${tableName}`;
        }

        // SQL escape helper
        const escapeSql = (value) => {
            if (value === null || value === undefined) {
                return 'NULL';
            }

            if (typeof value === 'number') {
                return value;
            }

            return `'${String(value).replace(/'/g, "''")}'`;
        };

        // Get columns from first record
        // Exclude auto-generated primary key
        const columns = Object.keys(data[0]).filter( column => !primaryKey || column !== primaryKey );

        // Generate VALUES
        const values = data.map(row => {
            const rowValues = columns.map(column => {

                // Use new value if supplied
                if (Object.prototype.hasOwnProperty.call(columnValues, column))
                    {
                        return escapeSql(columnValues[column]);
                    } 
                // Otherwise use original value
                return escapeSql(row[column]);
            });

            return `(${rowValues.join(', ')})`;
        });

        // Generate INSERT
        return `INSERT INTO ${tableName} (
            ${columns.join(',\n    ')}
        )
        VALUES
        ${values.join(',\n')};`;
    };


    useEffect(()=>{
        getInstalltions();
    },[])

    return (
        <div>
            <Header />
            <div className="main-container my-3">
                <div className="row m-2">
                    <div className="col-lg-2 col-xl-2 d-none d-lg-block d-xl-block">
                        <Sidenav/>
                    </div>
                    <div className="col-lg-10 col-xl-10">
                        <Paper elevation={2} sx={{ width: '100%', p: 3}}>
                            <Typography variant="body1" className="font-bold">Add Installation</Typography>
                            <form onSubmit={handleSubmit}>
                                <div className="row">
                                    <div className='col-lg-6'>
                                        <Autocomplete
                                            disablePortal
                                            id="combo-box-demo"
                                            options={installations}
                                            getOptionLabel={(option) => option.ins_description}
                                            name="selectedClonedIns"
                                            value={selectedClonedIns}
                                            onChange={(event, newValue)=>onInsSelect(newValue)}
                                            renderInput={(params) =>
                                            <TextField 
                                                {...params} id="standard-basic" 
                                                label="City" variant="standard" 
                                                className="width-90"
                                                helperText="Select the city that you want to clone."
                                                required
                                            />}
                                    />
                                    </div>
                                    <div className='col-md-6'>
                                        <TextField
                                            id="standard-basic" 
                                            label="Installation ID" variant="standard" 
                                            name="ins_id" value={inputField['ins_id']}
                                            className="width-90" onChange={handleChange}
                                            required/>
                                    </div>
                                    <div className='col-md-6'>
                                        <TextField
                                            id="standard-basic" 
                                            label="Installation Name" variant="standard" 
                                            name="ins_name" value={inputField['ins_name']}
                                            className="width-90" onChange={handleChange}
                                            required/>
                                    </div>
                                    <div className='col-md-12'>
                                        <Typography variant="h6" className="font-bold m-3 mb-5">Select Installation Geometry</Typography>
                                        <div className="row" style={{paddingBottom: "4rem"}}>
                                            <INS_GEOMETRY
                                                googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDcPvfjCIqeUpGe8_IaI_-5rIZX9qtCUnI&libraries=drawing,places"
                                                loadingElement={<div style={{ height: `100%` }} />}
                                                containerElement={<div style={{ height: `55vh` }} />}
                                                mapElement={<div style={{ height: `100%` }} />}
                                                center={center}
                                                zoom={16}
                                                geometry={geometry}
                                                ins_id={inputField.ins_id}

                                                setCenter={(value)=>{setCenter(value)}}
                                                setGeometry={(value)=>{setGeometry(value)}}
                                                removePolygon={(value)=>{setGeometry([])}}
                                                setGeometryQuery={(value)=>{setGeometryQuery(value)}}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2 }}>
                                    <Box sx={{ flex: '1 1 auto' }} />
                                    <Button type="submit" className="btn btn-blue px-3 fit-content">
                                        Add Installation
                                    </Button>
                                </Box>
                            </form>
                        </Paper>
                    </div>
                </div>
            </div>
            <Spinner
                spinner = {spinner}
            />
            <SnackAlert 
                msg={msg}
                alert={alert}
                severity={severity}

                closeAlert={()=>setAlert(false)}
            />
        </div>
    );
}
